import { z } from "zod";
export const auditKindSchema = z.enum([
  "person",
  "company",
  "integration",
  "activity",
  "run",
  "delivery",
  "source",
  "resource",
  "query",
  "member",
  "invitation",
  "attempt",
]);
export type AuditKind = z.infer<typeof auditKindSchema>;
export const auditActorSchema = z.object({
  id: z.string(),
  name: z.string(),
  kind: z.enum(["human", "service"]),
});
export type AuditActor = z.infer<typeof auditActorSchema>;
export const recordAuditSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  createdBy: auditActorSchema.nullable(),
  updatedBy: auditActorSchema.nullable(),
});
export const auditRequestSchema = z.object({
  kind: auditKindSchema,
  ids: z.array(z.uuid()),
});
